/* eslint-disable local-rules/set-state-in-use-effect */
import {doAsync} from '@aboutyou/utils';
import {useEffect} from 'react';
import {useSessionId} from './sessionStore/session.hooks';
import {
  TADARIDA_LOGOUT_BROADCAST_KEY,
  TADARIDA_OPTIONAL_USER_PERSIST_KEY,
  TADARIDA_SESSION_PERSIST_KEY,
  TADARIDA_USER_PERSIST_KEY,
} from './userStore/constants';
import {useUser} from './userStore/user.hooks';
import {useOptionalUser} from './userStore/userOptionalData.hooks';

export const BroadcastUserDataToTabs = {
  bc: (() => {
    if (typeof BroadcastChannel === 'undefined') {
      return null;
    }
    return new BroadcastChannel('USER_DATA_BROADCAST');
  })(),

  broadcastData: ({key, data}: {key: string; data?: object | null}) => {
    if (BroadcastUserDataToTabs.bc) {
      BroadcastUserDataToTabs.bc.postMessage({
        key,
        data,
      });
    }
  },
};

export const SyncSessionBetweenTabs = () => {
  const {data: sessionData, updateCache: updateSessionCache} = useSessionId();
  const {data: user, updateCache: updateUserCache} = useUser();
  const {data: optionalUser, updateCache: updateOptionalUserCache} =
    useOptionalUser();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (!BroadcastUserDataToTabs.bc) {
      return;
    }

    BroadcastUserDataToTabs.bc.onmessage = value => {
      requestAnimationFrame(() => {
        const key = value.data.key;
        const data = value.data.data;

        switch (key) {
          case TADARIDA_SESSION_PERSIST_KEY: {
            if (data && data?.sessionId !== sessionData?.sessionId) {
              updateSessionCache(data);
            }
            break;
          }
          case TADARIDA_USER_PERSIST_KEY: {
            if (JSON.stringify(data) !== JSON.stringify(user)) {
              updateUserCache(data);
            }
            break;
          }
          case TADARIDA_OPTIONAL_USER_PERSIST_KEY: {
            if (JSON.stringify(data) !== JSON.stringify(optionalUser)) {
              updateOptionalUserCache(data);
            }
            break;
          }
          case TADARIDA_LOGOUT_BROADCAST_KEY: {
            doAsync(() => {
              window.location.reload();
            });
            break;
          }
          default:
            break;
        }
      });
    };
  }, [
    optionalUser,
    sessionData?.sessionId,
    updateOptionalUserCache,
    updateSessionCache,
    updateUserCache,
    user,
  ]);

  return null;
};
